import React from "react";

const Button = ({
  iconStyle,
  variant = "filled",
  color,
  width,
  height,
  icon,
  isRightIcon,
  title,
  handleClick,
  isDisbaled,
  hoverColor,
  style
}) => {
  return (
    <button
      onClick={() => {
        if (isDisbaled) return;
        handleClick();
      }}
      style={{
        backgroundColor: variant === "filled" ? color : "transparent",
        border: variant === "outlined" ? `1px solid ${color}` : "none",
        color: variant === "outlined" ? color : "white",
        transition: "background-color 0.3s",
        width: width || "auto",
        height: height || "auto",
        ...style
      }}
      onMouseOver={(e) => {
        if (variant === "filled") {
          e.currentTarget.style.backgroundColor = hoverColor;
        } else if (variant === "outlined") {
          e.currentTarget.style.color = hoverColor;
        }
      }}
      onMouseOut={(e) => {
        if (variant === "filled") {
          e.currentTarget.style.backgroundColor = color;
        } else if (variant === "outlined") {
          e.currentTarget.style.color = color;
        }
      }}
      className={`
        text-white text-[14px] font-manrope font-[700]
        px-3 py-[7px] rounded-[4px]
        transition-colors duration-300
        ${width ? `w-[${width}]` : ""}
        transition-all duration-300 ease-in-out
        ${isDisbaled ? "opacity-60 cursor-not-allowed" : "opacity-100 cursor-pointer"}
        ${variant === "outlined" ? `border border-[${color}] bg-transparent text-[${color}]` : ""}
        ${variant === "filled" ? "border-none" : ""}
        flex ${icon ? "items-center gap-[8px]" : "justify-center"}
      `}
    >
      {icon && !isRightIcon && (
        <img
          src={icon}
          alt={"icon"}
          style={{ width: 14, height: 12, marginTop: "-1px", ...iconStyle }}
        />
      )}
      <span>{title}</span>
      {icon && isRightIcon && (
        <img
          src={icon}
          alt={"icon"}
          style={{ width: 14, height: 12, marginTop: "-1px", ...iconStyle }}
        />
      )}
    </button>
  );
};

export default Button;
